var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextCarousel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6006 23.2002L19.7881 31.0127C19.677 31.1162 19.5301 31.1726 19.3783 31.1699C19.2265 31.1672 19.0817 31.1057 18.9744 30.9984C18.867 30.891 18.8055 30.7462 18.8028 30.5944C18.8001 30.4426 18.8565 30.2957 18.96 30.1846L26.3575 22.7862L18.96 15.3877C18.8565 15.2767 18.8001 15.1297 18.8028 14.9779C18.8055 14.8261 18.867 14.6813 18.9744 14.574C19.0817 14.4666 19.2265 14.4051 19.3783 14.4024C19.5301 14.3998 19.677 14.4561 19.7881 14.5596L27.6006 22.3721C27.7103 22.482 27.772 22.6309 27.772 22.7862C27.772 22.9414 27.7103 23.0904 27.6006 23.2002Z",
    fill: "#383838"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.785156,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#383838"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCarousel);
export default __webpack_public_path__ + "static/media/next-carousel.d7dc96f154bdbfa050af4df260f10489.svg";
export { ForwardRef as ReactComponent };